import type { InputHTMLAttributes, ReactNode } from 'react';

import styles from '@/app/components/shared/dealer/styles.module.css';
import { cn } from '@/app/utils/cn';

interface BasePanelProps extends InputHTMLAttributes<HTMLDivElement> {
  className?: string;
  contentClassName?: string;
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}

export const BaseDealerPanel = ({
  className,
  contentClassName,
  header,
  footer,
  children,
  ...props
}: BasePanelProps) => {
  return (
    <div
      className={cn(
        'flex w-full flex-col overflow-hidden bg-white xl:rounded-lg xl:shadow-md',
        styles.basePanelContainer,
        {
          'p-4': !header && !footer,
        },
        className
      )}
      {...props}
    >
      {!!header && header}
      {!!children && (
        <div
          className={cn(
            'h-full flex-1 space-y-3 overflow-x-hidden overflow-y-auto pb-3',
            contentClassName
          )}
        >
          {children}
        </div>
      )}
      {!!footer && (
        <div className="fixed bottom-0 left-0 flex w-full items-center gap-x-4 bg-white px-4 py-3 xl:relative xl:rounded-b-xs">
          {footer}
        </div>
      )}
    </div>
  );
};
